var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "edg-navigation-sidebar",
        {
          staticClass: "navigation-bar",
          attrs: {
            folded: "",
            "selected-menu-item": _vm.selectedMenuItem,
            "menu-top": _vm.menuTop,
            "menu-middle": _vm.menuMiddle,
            "menu-bottom": _vm.menuBottom,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center m-7",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("div", { staticClass: "pl-2 title" }, [
                _vm._v(_vm._s(_vm.$t("navigation.title"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle d-flex flex-column ml-2" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("navigation.subtitle")))]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }